import { Base } from '@studiometa/js-toolkit';

/**
 * IngredientReadMore component
 * Handles the "read more" functionality for ingredient descriptions
 */
export default class IngredientReadMore extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'IngredientReadMore',
    refs: ['textShort', 'textFull', 'btnReadMore', 'btnReadLess'],
    options: {
      hasLongDescription: {
        type: Boolean,
        default: false,
      },
    },
  };

  /**
   * Current state - true for expanded, false for collapsed
   */
  isExpanded = false;

  /**
   * Mounted hook - initialize the component only if it has long description
   */
  mounted() {
    if (!this.$options.hasLongDescription) {
      return;
    }

    this.isExpanded = false;
    this.updateDisplay();
  }

  /**
   * Handle "Read More" button click
   */
  onBtnReadMoreClick() {
    this.isExpanded = true;
    this.updateDisplay();
  }

  /**
   * Handle "Read Less" button click
   */
  onBtnReadLessClick() {
    this.isExpanded = false;
    this.updateDisplay();
  }

  /**
   * Update the display based on current state
   */
  updateDisplay() {
    if (this.isExpanded) {
      this.$refs.textShort.classList.add('hidden');
      this.$refs.textFull.classList.remove('hidden');
      this.$refs.btnReadMore.classList.add('hidden');
      this.$refs.btnReadLess.classList.remove('hidden');
    } else {
      this.$refs.textShort.classList.remove('hidden');
      this.$refs.textFull.classList.add('hidden');
      this.$refs.btnReadMore.classList.remove('hidden');
      this.$refs.btnReadLess.classList.add('hidden');
    }
  }
}
